export default {
  commonMsg: {
    back: "返回",
    save: "保存",
    del: "删除",
    destroy: "注销",
    add: "添加",
    handle: "操作",
    No: "序号",
    new: "新增",
    edit: "编辑",
    replace: "替换",
    confirm: "确定",
    check: "查看",
    cancel: "取消",
    checkDetails: "查看详情",
    checkAll: "全选",
    sort: "排序",
    none: "无",
    rename: "重命名",
    author: "作者",
    status: "状态",
    search: "搜索",
    manage: "管理",
    release: "发布",
    cancelRelease: "取消发布",
    admin: "管理员",
    logout: "退出",
    move: "移动",
    remove: "移除",
    create: "创建",
    address: "地址",
    preview: "预览",
    upload: "上传",
    next: "下一页",
    prev: "上一页",
    failure: "失败",
    success: "成功",
    uploading: "上传中",
    pending: "待上传",
    tips: "提示",
    correction: "修正",
    detail: "详情",
    recovery: "回收",
    downLoadForecast: "下载模板",
    updatedAt: "更新时间",
    createdAt: "创建时间",
    export: "导出",
    startAt: "开始时间",
    endAt: "结束时间",
    date: "日期",
  },
  alertMsg: {
    success: "成功",
    fail: "失败",
    switchSuccess: "切换成功",
    soldOutSuccess: "下架成功",
    soldOnSuccess: "上架成功",
    addSuccess: "添加成功",
    addFailure: "添加失败",
    unlockSuccess: "成功解锁设备",
    saveSuccess: "保存成功",
    saveFailure: "保存失败",
    editSuccess: "编辑成功",
    editFailure: "编辑失败",
    moveSuccess: "移动成功",
    moveFailure: "移动失败",
    uploadSuccess: "上传成功",
    uploadFailure: "上传失败",
    modifySuccess: "修改成功",
    modifyFailure: "修改失败",
    delSuccess: "删除成功",
    delFailure: "删除失败",
    releaseSuccess: "发布成功",
    Unpublished: "已取消发布",
    releaseFailure: "发布失败",
    sortFailure: "排序失败",
    sortErr1: "外层书单不能排序",
    sortErr2: "不能跨外层书单排序",
    releaseChannel: "请选择发布频道",
    checkBook: "请先勾选书籍",
    uploadSize: "上传文件大小不能超过 100MB!",
    uploadFormat:
      "上传文件只能是 apk、epub、pdf、xlsx、xls、doc、docx、ppt、pptx、格式!",
    removeTip: "确定移除",
    selectTag: "请选择标签",
    uploadTip: "请上传文件或者等待文件上传完成再进行保存操作",
    userRole: "请填写角色",
    delConfirm: "确认删除该资源",
    delTitle: "删除弹窗",
    unlockConfirm: "确认解绑该设备？",
    unlockTitle: "解绑设备弹窗",
    addList: "添加列表弹窗",
    addGroup: "添加书单",
    refreshGroup: "更新书单",
    publicSuccess: "发布成功",
    recoverySuccess: "回收成功",
    existTitle: "该标题已存在",
    existWord: "该单词已存在",
  },
  placeholder: {
    name: "请输入名称",
    select: "请选择",
    enter: "请输入",
    bookName: "输入书籍名称（4-20字）",
    date: "选择日期",
    checkKey: "关键字查找",
    orgName: "输入机构名称",
    area: "输入地区",
    address: "输入地址",
    tagName: "输入标签名称",
    role: "请选择角色",
    dateTime: "选择日期时间",
  },
  // 路由
  router: {
    internalDevice: "研发样机管理",
    deviceActivation: "设备激活",
    content: "内容管理",
    orders: "订单管理",
    bookstore: "书城管理",
    vnBookstore: "越南书城",
    iGetBookstore: "得到书城",
    twBookstore: "台湾书城",
    book: "书籍管理",
    group: "所在书单",
    store: "前台书城",
    org: "机构管理",
    orgList: "机构列表",
    orgTag: "机构标签",
    storeConfig: "书城配置",
    screenConfig: "开关机屏保配置",
    users: "用户管理",
    roles: "权限管理",
    userRole: "用户账号权限",
    device: "设备管理",
    smsWhitelist: "短信白名单",
    upgrade: "固件升级管理",
    update: "版本更新",
    statistics: "数据统计",
    use: "使用统计",
    pcStats: "PC端统计",
    bookApp: "书城应用统计",
    ranking: "排行榜",
    booxCloud: "云盘相关统计",
    notesInfo: "云盘概况统计",
    libraryStats: "书库相关统计",
    market: "销售相关",
    coupon: "优惠券",
    advertisement: "广告",
    order: "订单",
    poetry: "诗词管理",
    dictionary: "单词字典",
    screensaver: "屏保管理",
    writeTemplate: "笔记背景图",
    urlParse: "网页解析规则",
    lang: "语言标签管理",
    devicesPower: "设备用电信息管理",
    devicesModelTag: "设备型号标签管理",
    devicesModel: "型号管理",
    staticBook: "预装书",
    motto: "格言管理",
    feedback: "信息反馈",
    feedbackInfo: "CB信息反馈",
    setting: "后台设置",
    gift: "活动管理",
    boox: "BOOX助手",
    booxApp: "软件更新",
    booxAdv: "助手广告",
    booxVersions: "版本管理",
    updateList: "更新记录",
    updatePublish: "发布版本",
    updateTest: "内测版本",
    updateApply: "申请内测",
    updateAdd: "新增",
    updateView: "详情",
    thank: "特别致谢",
    cookieContent: "cookie内容管理",
    serverMGT: "服务器管理",
    searchSite: "搜索站点管理",
    add: "新增",
    edit: "编辑",
    card: "卡片管理",
    introduction: "介绍说明",
    faq: "常见问题",
    screen: "投屏说明",
    privacy: "隐私政策",
    deviceInfo: "设备统计",
    usePowers: "权限使用情况",
    manual: "用户手册",
    couchbase: "Couchbase统计",
    feedbackTag: "反馈标签",
    sysNotice: "系统通知",
    loginAds: "网页端登录广告",
    rss: "RSS订阅",
    opds: "OPDS",
    wechatProduct: "微信硬件产品号管理",
    wechatIot: "微信硬件绑定用户统计",
    appConfManagement: "应用配置管理",
    appConf: "公共配置",
    appOptimization: "应用优化",
    godCode: "大神码",
    appConfTag: "应用配置标签",
    appConfGroup: "应用配置分组",
    serviceConfig: "服务配置管理",
    thirdParty: "第三方服务配置",
    booxClient: "PC端版本管理",
    ddosWarning: "DDOS预警配置",
    accessBlack: "接口请求屏蔽配置",
    testGroup: "测试组管理",
    permissionStat: "权限统计",
    systemConfig: "系统配置",
    chatGPT: "chatGPT统计",
    integratedData: "综合数据面板",
    gptContent: "GPT提示语管理",
    adminConfig: "配置",
    bookstoreStatic: "书城流量统计",
    ossStats: "oss统计",
  },
  // 登录
  login: {
    title: "内容管理平台",
    account: "用户名/手机号/邮箱",
    password: "密码",
    auto: "自动登录",
    forget: "忘记密码",
    logIn: "登录",
    find: "找回密码",
    email: "邮箱",
    send: "发送",
    tip: "请前往邮箱点击链接修改密码",
  },
  // 验证
  verify: {
    user: "请输入用户",
    password: "请输入密码",
    email: "请输入邮箱",
    groupName: "名称不能为空",
    name: "请输入名称",
    bookName: "请输入书籍名称",
    addClassify: "请选择分类添加",
    authorName: "请输入作者名称",
    price: "请输入价钱",
    bookDescription: "请输入书籍简介",
    cover: "请上传封面",
    condition: "请选择上架情况",
    orgName: "机构名称不能为空",
    orgAddress: "地址不能为空",
    orgId: "请输入机构编码",
    orgArea: "地区不能为空",
    num: "只能输入数字",
    tag: "标签不能为空",
    orgExist: "机构编码已存在",
    userRole: "请选择角色",
    phone: "请输入手机号",
    userName: "请填写登录名",
    userNameExist: "登录名已存在",
    firmwareModel: "请输入固件型号",
    firmwareBrand: "请输入固件品牌",
    firmwareVersion: "请输入固件版本",
    firmwareType: "请输入固件类型",
    firmwareLang: "请输入固件语言",
    firmwareMD5: "请输入固件MD5",
    firmwareScrnW: "请输入固件屏幕宽度",
    firmwareScrnH: "请输入固件屏幕高度",
    firmwareFingerprint: "请输入固件指纹信息",
    firmwareDownload: "请输入固件下载地址",
  },
  //内容管理
  content: {
    // 书籍管理
    books: {
      stack: "书籍管理",
      allBook: "全部图书",
      stackName: "类目名称",
      editGroup: "编辑书单",
      addToGroup: "添加到书单",
      modifyGroup: "修改书单",
      channelName: "频道名称",
      address: "跳转地址",
      groupName: "书单名称",
      bookCount: "书籍数量",
      onlineBook: "上线书籍",
      addBook: "添加书籍",
      pic: "封面图片",
      release: "发布频道",
      relate: "关联机构",
      one: "1星",
      two: "2星",
      three: "3星",
      four: "4星",
      five: "5星",
      online: "已上线",
      notOnline: "未上线",
      area_lang: "地区/语言",
      records: "共有记录",
      cover: "封面",
      bookName: "书籍名称",
      views: "浏览量",
      sales: "销售量",
      readers: "读者评分",
      price: "价格",
      all: "全部",
      classify: "分类",
      group: "所在书单",
      status: "当前状态",
      cn: "中文简体",
      tc: "中文繁体",
      en: "英文",
      inspirational: "励志",
      literature: "文学",
      technology: "科技",
      biography: "传记",
      score: "评分",
      bookDetails: "书籍详情",
      content: "内容简介",
      directory: "目录",
      author: "作者简介",
      comment: "书籍评论",
      allComment: "书籍评论",
      good: "好评",
      normal: "中评",
      bad: "差评",
      basic: "基本信息",
      chapter: "章节目录",
      chapterName: "章节名称",
      addChapter: "添加章",
      addSection: "添加节",
      rename: "修改名称",
      addClassify: "添加分类",
      editClassify: "编辑分类",
      addChannel: "添加频道",
      editChannel: "编辑频道",
      priceTip: "必须为数字，如：10（当输入0时，会在网站显示：免费）",
      picRemark: "备注：宽180px 高222px图片最合适，大小不要超过 50 M",
      fileSize: "文件大小",
      fileFormat: "文件格式",
      count: "字数",
      publisher: "出版社",
      publish_time: "出版时间",
      edition: "版次",
      bookDescription: "书籍简介",
      condition: "上架情况",
      putaway: "默认上架",
      notPutaway: "默认不上架",
      selectClassify: "选择分类",
      addGroup: "加入书单",
      selectGroup: "选择书单",
      setPrice: "设置价格",
      soldOut: "下架",
      soldOn: "上架",
      hasComment: "已有评价",
      name: "名称",
      moveClassify: "移动到分类",
      new: "最新",
      top: "畅销",
      addTo: "添加到",
      publish: "出版",
      boy: "男生",
      girl: "女生",
      uploadFile: "上传文件",
      selectFile: "选取文件",
      uploadTip: "只能上传1文件，且不超过100MB",
      uploadServer: "上传到服务器",
      createTip: "请先上传文件成功",
      releaseTo: "发布到",
      timingOn: "定时上架",
      shelfTime: "请选择上架时间",
      showDevice: "设备显示",
      show: "显示",
      notShow: "不显示",
      batchUpload: "批量上传书籍",
      batchUploadTips: "请将文件拖到这里，或点击添加文件按钮",
      addFile: "添加文件",
      startUpload: "开始上传",
    },
    // 前台书城
    store: {
      channel: "频道管理",
      banner: "轮播图",
      frame: "框架管理",
      channelPreview: "网站预览频道",
      channelSelected: "网站已选频道",
      channelName: "频道",
      channelOpen: "打开方式",
      bannerPreview: "网站预览轮播图",
      bannerSelected: "网站可选轮播图",
      addBanner: "新增轮播图",
      bannerTitle: "轮播图",
      bannerName: "名称",
      bannerMove: "移动",
      bannerLink: "链接",
      framePreview: "首页框架预览",
      permission: "权限管理",
    },
  },

  // 机构管理
  org: {
    country: "国家",
    batch: "批量配置",
    orgName: "机构名称",
    tag: "标签",
    apps: "超星应用模块",
    manage: "管理",
    module: "应用模块",
    address: "访问地址",
    optionalCX: "可选超星应用",
    selectedCX: "已选超星应用",
    CX: "超星应用",
    store: "书城配置",
    channel: "频道",
    frame: "框架",
    banner: "轮播图",
    library: "专题书库",
    optionallibrary: "可选专题书库",
    selectedlibrary: "已选专题书库",
    area: "地区",
    deviceCount: "设备数(台)",
    usersInfo: "设备用户信息",
    otherInfo: "其他信息",
    newOrg: "新增机构",
    updateOrg: "更新机构",
    selectArea: "选择地区",
    orgId: "机构编码",
    orgAddress: "机构地址",
    fliqlo: "开关机屏保配置",
    fliqloTip: "（可通过开关机屏保配置进行更改）",
    powerOff: "关机动画",
    powerOn: "开机动画",
    standby: "待机屏保",
    storeChannel: "书城频道",
    storeFrame: "书城框架",
    storeBanner: "书城轮播图",
    newDevice: "新增设备",
    exportUsers: "导出用户信息",
    macAddress: "设备MAC地址",
    userAccount: "登录用户账号",
    userName: "登录用户名称",
    userRole: "登录用户角色",
    updated_at: "最后登录时间",
    addOrg: "添加机构",
    exportTag: "导出标签信息",
    orgTag: "机构标签",
    addTag: "新增标签",
    tagName: "标签名称",
    orgCount: "机构数",
    sync: "同步信息",
    exportDevice: "导出设备信息",
    importDevice: "导入设备",
  },

  // 用户管理
  user: {
    giftCode: "礼品卡号",
    username: "用户名称",
    userName: "登录名/用户名/用户ID",
    addUser: "新增用户",
    name: "登录名",
    id: "用户ID",
    nickname: "昵称",
    nicknameOld: "曾用名",
    email: "邮箱",
    role: "角色",
    selectRole: "选择角色",
    addRole: "新增角色",
    optionalPermission: "可选权限",
    selectedPermission: "已选权限",
    roleName: "角色名",
    permission: "权限管理",
    macAddress: "设备地址",
    unbind: "解绑",
    resetPsw: "重置密码",
    lockStatus: "锁定状态",
    model: "型号",
    unlock: "解锁",
    users: "用户管理",
    password: "密码",
    phone: "手机号码",
    remark: "备注",
    selectOrg: "选择机构",
    select: "点击选择",
    lock: "锁定",
    devices: "关联设备数量",
    storageLimit: "云盘容量",
    mac: "mac",
  },

  // 固件升级管理
  firmware: {
    updateFirmware: "更新固件",
    addFirmware: "添加固件",
    model: "型号",
    brand: "品牌",
    versions: "版本",
    type: "类型",
    lang: "语言",
    scrnW: "屏幕宽度",
    scrnH: "屏幕高度",
    fingerprint: "指纹信息",
    upgrade: "升级版本",
    downLoad: "下载地址",
    changeMsg: "变更信息",
    time: "时间",
    MAC: "设备MAC",
    MACTip: "输入不同的MAC地址，请换行输入",
  },

  // 销售相关
  sale: {
    coupon: {
      title1: "优惠券",
      details: "优惠券详情",
      activity: "活动名称",
      type: "类型",
      publishAt: "发布时间",
      endAt: "到期时间",
      gets: "领取",
      minus: "额度",
      discount: "折扣",
      num: "数量",
      useRange: "选择范围",
      valid: "有效期",
      userList: "目标账号",
      discountCoupon: "折扣卷",
      deduction: "抵扣卷",
      all: "全部",
      monthly: "月度",
      quarter: "季度",
      year: "年度",
      yuan: "元",
      zhe: "折",
      title2: "新增优惠券",
      inputPublishAt: "请输入发布时间",
      inputStartAt: "请输入开始时间",
      inputEndAt: "请输入到期时间",
      inputMinus: "请输入优惠数值",
      inputNum: "请输入数值",
      inputActivity: "请输入活动名称",
      tips1: "单位：毛",
      tips2: "范围 0 ～ 1",
      tips3: "优惠券生成成功！",
      tips4: "目标账号数已超出！",
      verify1: "请输入折扣数值",
      verify2: "折扣数值不能大于1",
      verify3: "折扣数值不能小于0",
      verify4: "请输入数值",
      verify5: "请输入正整数",
    },
    orders: {
      title: "订单",
      userPin: "用户pin",
      des: "描述",
      vip_type: "vip类型",
      fee_type: "支付方式",
      pay_time: "支付时间",
      total: "总金融额",
      status: "支付状态",
      out_trade_no: "流水号",
    },
    gift: {
      title: "礼品中心",
      title1: "新增礼品卡",
      theme: "活动主题",
      type: "类型",
      giftCard: "礼品卡",
      commodityCard: "商品卡",
      validity: "有效期",
      price: "价格",
      startAt: "开始时间",
      endAt: "结束时间",
      activityTime: "活动时间",
      inputStartAt: "请输入开始时间",
      inputEndAt: "请输入结束时间",
      num: "发行数量",
      gets: "领取数量",
      mac: "MAC（选填）",
      handle: "操作历史",
      verify1: "不能为空",
      verify2: "不能小于等于0",
      verify3: "只能输入数字",
    },
    card: {
      name: "名称",
      title: "卡片管理",
      title1: "新增礼品卡",
      theme: "活动主题",
      type: "类型",
      giftCard: "礼品卡",
      commodityCard: "商品卡",
      validity: "有效期",
      price: "价格",
      startAt: "开始时间",
      endAt: "结束时间",
      activityTime: "活动时间",
      inputStartAt: "请输入开始时间",
      inputEndAt: "请输入结束时间",
      num: "发行数量",
      gets: "领取数量",
      mac: "MAC（选填）",
      handle: "操作历史",
      verify1: "不能为空",
      verify2: "不能小于等于0",
      verify3: "只能输入数字",
      liveAt: "有效期",
      cardCount: "总量",
      cardOutCount: "已派发",
      cardResCount: "剩余",
      importCard: "请导入礼品卡",
      inputCode: "请输入卡号",
      import: "导入",
      success: "成功",
      fail: "失败",
      item: "个",
    },
  },

  // 设备管理
  devices: {
    poetry: {
      name: "标题",
      title: "诗词管理",
      title1: "新增诗词库",
      theme: "活动主题",
      type: "类型",
      giftCard: "礼品卡",
      commodityCard: "商品卡",
      validity: "有效期",
      price: "价格",
      startAt: "开始时间",
      endAt: "结束时间",
      activityTime: "活动时间",
      inputStartAt: "请输入开始时间",
      inputEndAt: "请输入结束时间",
      num: "数量",
      mac: "MAC（选填）",
      handle: "操作历史",
      verify1: "不能为空",
      verify2: "不能小于等于0",
      verify3: "只能输入数字",
      liveAt: "有效期",
      cardCount: "总量",
      cardOutCount: "已派发",
      cardResCount: "剩余",
      importCard: "请导入礼品卡",
      inputCode: "请输入卡号",
      import: "导入",
      success: "成功",
      fail: "失败",
      item: "个",

      author: "作者",
      lang: "语言",
      publishStatus: "发布状态",
      inputTitle: "请输入标题",
      inputContent: "请输入内容",
    },
    dictionary: {
      name: "标题",
      title: "单词字典",
      title1: "新增单词分类",
      title2: "新增单词",
      theme: "活动主题",
      type: "类型",
      giftCard: "礼品卡",
      commodityCard: "商品卡",
      validity: "有效期",
      price: "价格",
      startAt: "开始时间",
      endAt: "结束时间",
      activityTime: "活动时间",
      inputStartAt: "请输入开始时间",
      inputEndAt: "请输入结束时间",
      num: "数量",
      mac: "MAC（选填）",
      handle: "操作历史",
      verify1: "不能为空",
      verify2: "不能小于等于0",
      verify3: "只能输入数字",
      liveAt: "有效期",
      cardCount: "总量",
      cardOutCount: "已派发",
      cardResCount: "剩余",
      importCard: "请导入礼品卡",
      inputCode: "请输入卡号",
      import: "导入",
      success: "成功",
      fail: "失败",
      item: "个",

      author: "作者",
      lang: "语言",
      publishStatus: "发布状态",
      inputTitle: "请输入标题",
      inputContent: "请输入内容",

      word: "单词",
      phonetic: "音标",
      translations: "翻译",
      inputWord: "请输入单词",
    },
    motto: {
      name: "标题",
      title: "格言管理",
      title1: "新增格言分类",
      title2: "新增格言",
      theme: "活动主题",
      type: "类型",
      giftCard: "礼品卡",
      commodityCard: "商品卡",
      validity: "有效期",
      price: "价格",
      startAt: "开始时间",
      endAt: "结束时间",
      activityTime: "活动时间",
      inputStartAt: "请输入开始时间",
      inputEndAt: "请输入结束时间",
      num: "数量",
      mac: "MAC（选填）",
      handle: "操作历史",
      verify1: "不能为空",
      verify2: "不能小于等于0",
      verify3: "只能输入数字",
      liveAt: "有效期",
      cardCount: "总量",
      cardOutCount: "已派发",
      cardResCount: "剩余",
      importCard: "请导入礼品卡",
      inputCode: "请输入卡号",
      import: "导入",
      success: "成功",
      fail: "失败",
      item: "个",

      author: "作者",
      lang: "语言",
      publishStatus: "发布状态",
      inputTitle: "请输入标题",
      inputContent: "请输入内容",

      motto: "格言",
      phonetic: "音标",
      translations: "翻译",
      inputMotto: "请输入格言",
    },
    power: {
      title: "标题",
    },
    staticBook: {
      title: "预装书",
    },
  },

  boox: {
    title1: "软件更新",
    title2: "标题",
    title3: "发布记录",
    title4: "APK管理",
    type: "类型",
    version: "版本",
    inputVersion: "请输入版本号",
    lang: "语言",
    description: "简介",
    introduce: "介绍",
    comment: "备注",
    file: "文件",
    region: "区域",
  },

  update: {
    category: "类别",
    title: "标题",
    type: "类型",
    version: "版本",
    lang: "语言",
    description: "简介",
    introduce: "介绍",
    comment: "备注",
    file: "文件",
    region: "区域",
    inputTitle: "请输入标题",
  },

  server: {
    name: "名字(默认显示)",
    host: "域名",
    ossConfig: "oss配置",
    lang: "语言",
    langGroup: "多语言",
    region: "区域",
    inputLang: "请输入语言",
    inputName: "请输入名字",
    inputRegion: "请输入区域",
    errDomain: "域名格式不正确",
  },

  // starNote学院
  college: {
    title: "starNote学院",
    generalSettings: "通用配置",
    dataCenterSettings: "资料中心首页配置",
    materialCenterSettings: "素材中心首页配置",
    library: "资料库",
    libraryMgmt: "资料库管理",
    libraryCategoryMgmt: "资料库分类管理",
    templateLibrary: "模版库",
    stickerLibrary: "贴纸库",
    promotionCode: "运营口令",
    tagMgmt: "标签管理",
    publisherMgmt: "发布人管理",
    addPrimaryCategory: "添加一级分类",
    addData: "添加资料",
    primaryCategory: "一级分类",
    secondaryCategory: "二级分类",
    tertiaryCategory: "三级分类",
    loading: "正在加载~",
    allDataLoaded: "数据已经全部加载完啦~",
    pleaseSelectCategory: "请选择分类",
    deleteCategoryConfirm: "删除后所有内容与分类均不在展示，是否确认删除?",
    removeDataConfirm: "移除内容后，则不在此分类下展示，是否确认移除?",
    codeGeneration: "运营口令生成",
    codeLibrary: "运营口令文案库",
    generateCode: "生成运营口令",
    editCode: "编辑运营口令",
    deleteCodeConfirm: "是否确认删除文案?",
    inputCategoryNameZh: "请输入简体分类名称",
    inputCategoryNameTw: "请输入繁体分类名称",
    inputCategoryNameEn: "请输入英文分类名称",
    categoryNameHint: "（xx个字内）",
    addCategory: "添加分类",
    editCategory: "编辑分类",
    deleteCategory: "删除分类",
    addSubCategory: "添加子分类",
    editSubCategory: "编辑子分类",
    deleteSubCategory: "删除子分类",
    modelGroup: "型号组管理",
  },
};
